import React from "react";

import { Label } from "@client/shadcn/ui/label";

interface Props {
    className?: string;
}

export const Footer = (props: Props) => {
    return (
        <footer className="m-8">
            <Label htmlFor="copyright" className="justify-center">© {new Date().getFullYear()} Oxford University Press. All rights reserved.</Label>
        </footer>
    );
};
